import { ConcreteEncodable } from "./ConcreteEncodable";

import { PingTimerImplEncoder } from "../../encoder/PingTimerImplEncoder";

import * as CubiqTS from "../../index";
import { PingTimer } from "../PingTimer";

export class PingTimerImpl extends ConcreteEncodable implements PingTimer {
  public static enType: string = "com.bcdfx.model.event.PingTimerImpl";

  /*FID=1*/
  public uiTxTime: CubiqTS.Long | null = null;
  /*FID=2*/
  public uiRxTime: CubiqTS.Long | null = null;
  /*FID=3*/
  public serverRxTime: CubiqTS.Long | null = null;
  /*FID=4*/
  public serverTxTime: CubiqTS.Long | null = null;
  /*FID=5*/
  public serverIsProxy: boolean | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PingTimerImplEncoder.Instance;
    this.setEncodableType(PingTimerImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "PingTimerImpl[" +
      "uiTxTime=" +
      this.uiTxTime +
      "uiRxTime=" +
      this.uiRxTime +
      "serverRxTime=" +
      this.serverRxTime +
      "serverTxTime=" +
      this.serverTxTime +
      "serverIsProxy=" +
      this.serverIsProxy +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
